import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import * as Cookies from 'js-cookie';
// import { FormattedMessage } from 'react-intl';
import { injectIntl, intlShape } from 'react-intl';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { setLocation } from 'shared/actions/globals';
import ModalWrapper from 'shared/components/ModalWrapper/ModalWrapper';
import CircleTimer from 'shared/components/LeasingOnlineBanner/CircleTimer/CircleTimer';
import { toLocalized } from 'shared/helpers/locale';
import { Button } from 'shared/components/UI';

import history from '../../../history';

import s from './ChooseLanguageDialog.css';

const cookieKey = 'chlc';

class ChooseLanguageDialog extends React.Component {
  static propTypes = {
    changeLocation: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
  };
  state = {
    showModal: true,
  };

  onChoose = lang => {
    Cookies.set(cookieKey, lang);
    const redirectUrl = toLocalized(history.location.pathname, lang);
    this.props.changeLocation(redirectUrl);
    history.push(redirectUrl);
    window.location.reload();
  };

  render() {
    const {
      intl: { locale },
    } = this.props;

    const pathname = history && history.location && history.location.pathname;
    const lng = Cookies.get(cookieKey);
    if (locale === 'uk' || lng || pathname !== '/') return null;

    const time = 10;

    return (
      <ModalWrapper toggleModal={() => {}} show={this.state.showModal}>
        <h3 className={s.title}>Оберіть мовну версію сайту</h3>
        <div className={s.text}>
          Якщо ви не зробите вибір, Вас буде автоматично направлено на версію українською мовою
          через 10 секунд…
        </div>
        <div className={`${s.timer} container-center`}>
          <CircleTimer
            time={time}
            timeUp={() => {
              this.onChoose('uk');
            }}
          />
        </div>
        <div className={s.buttons}>
          <Button
            type="button"
            userTranslate={false}
            text="Залишитись на українській"
            onClick={() => this.onChoose('uk')}
          />
          <Button
            type="button"
            userTranslate={false}
            text="Перейти на російську"
            theme="DisabledStyle"
            onClick={() => this.onChoose('ru')}
          />
        </div>
      </ModalWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  changeLocation: bindActionCreators(setLocation, dispatch),
});
export default connect(
  null,
  mapDispatchToProps,
)(withStyles(s)(injectIntl(ChooseLanguageDialog)));



// WEBPACK FOOTER //
// ./src/shared/components/ChooseLanguageDialog/ChooseLanguageDialog.js